import { useState, useEffect } from 'react';
import { getAssetPath } from "../utils/get-asset-path.js";

const memoryCache = new Map();

const useCachedImage = (url, cacheName, customFallback = null) => {
  const [src, setSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const defaultFallback = getAssetPath("img/sentry.imgnotfound.large.748x480.png");
  const fallbackUrl = customFallback || defaultFallback;

  useEffect(() => {

    if (!url) {
      setSrc(fallbackUrl);
      setIsLoading(false);
      return;
    }

    let isMounted = true;
    let objectUrl = null;

    const loadImage = async () => {
      setIsLoading(true);

      if (memoryCache.has(url)) {
        if (isMounted) {
          setSrc(memoryCache.get(url));
          setIsLoading(false);
        }
        return;
      }

      try {
        const fetchUrl = import.meta.env.DEV ? url.replace("/keeper", "/keeperProxy") : url;
        const response = await fetch(fetchUrl);

        if (response.ok) {
          const blob = await response.blob();
          objectUrl = URL.createObjectURL(blob);

          memoryCache.set(url, objectUrl);

          if (isMounted) setSrc(objectUrl);
        } else {
          if (isMounted) setSrc(fallbackUrl);
        }
      } catch (error) {
        if (isMounted) setSrc(fallbackUrl);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadImage();

    return () => {
      isMounted = false;
    };
  }, [url, fallbackUrl]);

  return { src, isLoading };
};

export default useCachedImage;